var React = require('react');

function Highlight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h24v24H0V0z","id":"a"})),React.createElement("clipPath",{"id":"b","key":1},React.createElement("use",{"overflow":"visible","xlinkHref":"#a"})),React.createElement("path",{"clipPath":"url(#b)","d":"M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z","key":2})]);
}

Highlight.displayName = "Highlight";

Highlight.defaultProps = {"fill":"#000000","height":"48","viewBox":"0 0 24 24","width":"48"};

module.exports = Highlight;

Highlight.default = Highlight;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/highlight.svg